import(/* webpackMode: "eager" */ "/app/src/app/[company]/page.tsx");
